import * as React from 'react';
import { Paper as MatPaper, SxProps, Theme } from '@mui/material';

export interface PaperProps {
  elevation?: number;
  square?: boolean;
  className?: string;
  children?: any;
  sx?: SxProps<Theme>;
}

const useStyles = (): Record<string, SxProps<Theme>> => ({
  root: {
    padding: 2
  }
});

const Paper: React.FunctionComponent<PaperProps> = React.forwardRef<HTMLDivElement, PaperProps>(({ className, sx, ...restProps }, ref) => {
  const { root } = useStyles();
  const sxProps = [root, sx] as SxProps<Theme>;
  return <MatPaper ref={ref} className={className} sx={sxProps} {...restProps} />;
});

Paper.defaultProps = {
  elevation: 4,
  square: false
};

Paper.displayName = 'Paper';

export { Paper };
